import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap'
import { Channel, RateService, Rental, RentalBookedDayTypes } from '@tokeet/tv3-platform'
import { MonthDayView } from '../rate-services/rate.view'
import { isEqual, uniqWith } from 'lodash'

@Component({
  selector: 'app-rental-rates-calendar-cell',
  templateUrl: './rental-rates-calendar-cell.component.html',
  styleUrls: ['./rental-rates-calendar-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RentalRatesCalendarCellComponent {
  @Input() rental: Rental
  @Input() channels: Record<string, Channel>
  @Input() day: number
  _data: MonthDayView
  @Input() set data(d: MonthDayView) {
    this._data = { ...d, rates: uniqWith(d?.rates, isEqual) }
  }
  get data() {
    return this._data
  }

  @Input() events: number
  @Input() booked: RentalBookedDayTypes
  @Input() today: boolean
  @Input() startOfMonth: boolean
  @Input() beforeToday: boolean
  @Input() showPopover: boolean

  @Output() activePopover = new EventEmitter<NgbPopover>()

  constructor(private rateService: RateService) {}

  getClass() {
    return {
      'has-data': this.data,
      booked: this.booked,
      today: this.today,
      'before-today': this.beforeToday,
      [this.booked]: true,
    }
  }

  get isWeekend() {
    return this.rateService.isWeekend(this.day)
  }

  get showContent() {
    return !this.events && !this.beforeToday && (!this.booked || this.booked === 'end') && this.data
  }

  openPopover(popover: NgbPopover) {
    if (!this.showPopover || !this.showContent) return

    popover.open()
    this.activePopover.emit(popover)
  }
}
